export const API_GET_TEAM_MEMBERS_REQUEST = 'API_GET_TEAM_MEMBERS_REQUEST';
export const API_GET_TEAM_MEMBERS_SUCCESS = 'API_GET_TEAM_MEMBERS_SUCCESS';
export const API_GET_TEAM_MEMBERS_FAILURE = 'API_GET_TEAM_MEMBERS_FAILURE';
export const RESET_TEAM_MEMBERS = 'RESET_TEAM_MEMBERS';

export const SELECT_TEAM_MEMBER = 'SELECT_TEAM_MEMBER';

export const FILTER_TEAM_MEMBERS = 'FILTER_TEAM_MEMBERS';

export const filterTeamMembers = payload => ({
  type: FILTER_TEAM_MEMBERS,
  payload,
});

export const selectTeamMember = payload => ({
  type: SELECT_TEAM_MEMBER,
  payload,
});

export const resetTeamMembers = () => ({
  type: RESET_TEAM_MEMBERS,
});

export const getTeamMembersRequest = () => ({
  type: API_GET_TEAM_MEMBERS_REQUEST,
});

export const getTeamMembersSuccess = payload => ({
  type: API_GET_TEAM_MEMBERS_SUCCESS,
  payload,
});

export const getTeamMembersFailure = payload => ({
  type: API_GET_TEAM_MEMBERS_FAILURE,
  payload,
});

const initialState = {
  searchTerm: '',
  selectedTeamMemberId: null,
  isFetched: false,
  fetching: false,
  error: null,
  users: null,
};

export function teamMembersReducer(state = initialState, action) {
  switch (action.type) {
    case FILTER_TEAM_MEMBERS:
      return {
        ...state,
        searchTerm: action.payload,
      };
    case SELECT_TEAM_MEMBER:
      return {
        ...state,
        selectedTeamMemberId: action.payload,
      };
    case RESET_TEAM_MEMBERS:
      return {
        ...state,
        users: null,
        isFetched: false,
      };
    case API_GET_TEAM_MEMBERS_REQUEST:
      return {
        ...state,
        fetching: true,
      };
    case API_GET_TEAM_MEMBERS_SUCCESS:
      return {
        ...state,
        isFetched: true,
        fetching: false,
        users: action.payload.users,
      };
    case API_GET_TEAM_MEMBERS_FAILURE:
      return {
        ...state,
        fetching: false,
        isFetched: false,
        error: action.payload,
      };
    default:
      return state;
  }
}
